<template>
  <div id="app">
    <Head />
    <router-view />
    <Foot />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Foot from "@/components/Foot.vue";

export default {
  name: "Home",
  components: {
    Head,
    Foot,
  },
};
</script>
<style lang="less">
@import "./assets/font/font.css";

body {
  background: #f7f8fc;
}

* {
  margin: 0;
  padding: 0;
}

/deep/ .el-input__inner {
  border-radius: unset;
}

/deep/ .el-popconfirm_action {
  margin: unset !important;
  margin-bottom: 10px !important;
}
</style>
